import type { CSSProperties } from 'react';
import type { Theme } from '@mui/material';

/**
 * The size of a procedure code, in a chip and in the list behind a fold: the
 * theme's caption size, which is also the size of its xSmall Chip. One
 * resolver for both so the chip and its list cannot drift apart.
 */
export const codeFontSize = (theme: Theme): CSSProperties['fontSize'] =>
  theme.typography.caption.fontSize;
